<template>
  <div>
    <q-page v-if="index_ready" class="flex">
      <div
        v-if="index_ready"
        class="row fit no-wrap items-stretch content-start q-col-gutter-sm"
      >
        <div class="col-4 q-px">
          <div class="column no-wrap justify-start items-stretch content-start">
            <div class="col-auto">
              <q-select
                filled
                v-model="search_mode"
                :options="search_mode_options"
                label="Modo de busca"
              />
            </div>
            <div class="col-auto">
              <q-input v-model="search_expression" label="Buscar" />
            </div>
          </div>
        </div>
        <div class="col-8 q-px">
          <div v-if="search_results" class="fit overflow-auto">
            <q-list v-if="search_mode.value === 'paragraph'" bordered separator>
              <q-item
                clickable
                v-ripple
                v-for="item in search_results"
                :key="item.ref"
                @click="copy_to_clipboard(paragraphs[item.ref].text)"
              >
                <q-item-section>
                  <ParagraphView
                    :match-data="item"
                    :corpus="paragraphs"
                    text-field="text"
                  />
                </q-item-section>
              </q-item>
            </q-list>
            <pre v-else>
              {{ stringified_search_results }}
            </pre>
          </div>
          <div v-else class="fit overflow-auto">
            <p>
              Nada
            </p>
          </div>
        </div>
      </div>
    </q-page>
    <q-page v-else class="flex flex-center">
      <div class="q-px q-py">
        <q-spinner-cube color="accent" size="10.0em" />
      </div>
    </q-page>
  </div>
</template>

<style></style>

<script>
import firebase from "@/firebase";
import { copyToClipboard } from "quasar";
import { lunr } from "@/lunr_common";
import worker_factory from "../lunr.worker.js";
import ParagraphView from "@/components/paragraph-view.vue";

const database = firebase.database();

const search_mode_options = [
  {
    value: "document",
    label: "Documentos"
  },
  {
    value: "paragraph",
    label: "Parágrafos"
  }
];
const default_search_mode = search_mode_options[1];

console.log(worker_factory);

export default {
  name: "Home",

  props: {
    currentUid: String
  },

  watch: {
    currentUid: function() {
      this.start_listener();
    }
  },

  data: function() {
    return {
      index_ready: false,
      documents: null,
      paragraphs: null,

      search_mode: default_search_mode,
      search_mode_options,
      search_expression: ""
    };
  },

  computed: {
    search_results: function() {
      const search_expression = this.search_expression;
      const search_mode = this.search_mode;

      if (!this.index_ready) return null;
      if (search_expression.trim().length === 0) return null;

      if (search_mode.value === "document") {
        const results = this._document_index.search(search_expression);
        return results;
      } else {
        const results = this._paragraph_index.search(search_expression);
        return results;
      }
    },

    stringified_search_results: function() {
      return JSON.stringify(this.search_results, null, 2);
    }
  },

  methods: {
    start_listener: function() {
      this.stop_listener();
      this.index_ready = false;
      this.documents = null;
      this.paragraphs = null;
      const vue_this = this;
      const my_ref = (this._ref = database.ref(
        `users/${this.currentUid}/requests`
      ));

      this._worker = worker_factory();
      this._worker.onmessage = evt => {
        console.log(`Received worker response data: ${evt.data.length}`);
        const response = JSON.parse(evt.data);
        this._document_index = lunr.Index.load(response.document_index);
        this._paragraph_index = lunr.Index.load(response.paragraph_index);
        this.documents = response.documents;
        this.paragraphs = response.paragraphs;
        this.index_ready = true;
        console.log(this);
      };

      this._ref.on("value", function(snap) {
        if (vue_this._ref !== my_ref) return;
        const data = snap.val();
        console.log(`Received database update: ${Object.keys(data).length}`);
        vue_this._worker.postMessage(data);
      });
    },

    stop_listener: function() {
      if (this._ref) {
        this._ref.off();
        this._ref = null;
      }
      if (this._worker) {
        this._worker.terminate();
        this._worker = null;
      }
    },

    copy_to_clipboard(text) {
      copyToClipboard(text);
    }
  },

  mounted: function() {
    this.start_listener();
  },

  beforeDestroy: function() {
    this.stop_listener();
  },

  components: {
    ParagraphView
  }
};
</script>
